import { render, staticRenderFns } from "./WordingModal.vue?vue&type=template&id=25034ad0&scoped=true&"
import script from "./WordingModal.vue?vue&type=script&lang=js&"
export * from "./WordingModal.vue?vue&type=script&lang=js&"
import style0 from "./WordingModal.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./WordingModal.vue?vue&type=style&index=1&id=25034ad0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25034ad0",
  null
  
)

export default component.exports